
const baseurl = 'https://paysprint.ca/api/v1/marketplace';
// const baseurl = 'http://localhost:9090/api/v1/marketplace';

export default baseurl;